import React, { Component } from "react";
import { Drawer, Select, Spin } from "antd";
import instance from "@/store/actions/instance";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import InvoiceViewer from "../Products/InventoryMovementsTab/InvoiceViewer";

const { Option } = Select;

class CreateOrderDrawer extends Component {
  state = {
    loadingCustomers: false,
    selectedCustomerId: null,
    selectedCustomer: null,

    loadingAddresses: false,
    customerAddresses: null,
    selectedAddress: null,
    selectedAddressId: null,

    iframeReady: false,
    searchResults: [],
    didSearch: false,
    searching: false,

    selectedOrderTrackingId: null,
  };

  searchTimeout = null;

  componentDidMount() {
    window.addEventListener("message", this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
  }

  handleMessage = (event) => {
    if (event.data.type === "ORDER_COMPLETED") {
      this.setState({ selectedOrderTrackingId: event.data.orderTrackingId });
    }
  };
  searchCustomers = async (q) => {
    try {
      const res = await instance.post("/search_customers/", {
        q,
        limit: 20,
      });

      return res.data?.customers_list || res.data?.results || [];
    } catch (err) {
      console.error(err);
      return [];
    }
  };
  onSearchCustomer = (q) => {
    clearTimeout(this.searchTimeout);

    const query = (q || "").trim();

    // if empty -> show nothing (zero DOM options)
    if (!query) {
      this.setState({ searchResults: [], searching: false });
      return;
    }

    this.searchTimeout = setTimeout(async () => {
      this.setState({ searching: true });

      try {
        // ✅ BEST: call your backend with q + limit
        const results = await this.searchCustomers(query); // returns top 20/50
        this.setState({ searchResults: results || [] });
      } finally {
        this.setState({ searching: false, didSearch: true });
      }
    }, 250);
  };

  iframeRef = React.createRef();

  onSelectCustomer = async (customerId) => {
    const c = (this.state.searchResults || []).find((x) => x.id === customerId);
    let newCustomerAddresses = null;
    if (customerId && customerId != "New") {
      this.setState({
        loadingAddresses: true,
        selectedAddress: null,
        selectedAddressId: false,
      });
      try {
        let res = await instance.post("get_customer_addresses/", {
          includeBranch: true,
          key: customerId,
        });
        newCustomerAddresses = res.data.filter(
          (a) => a.branch_delivery_charge !== null,
        );
      } catch (error) {
        console.log(error);
      }
    }

    this.setState({
      selectedCustomerId: customerId,
      selectedCustomer: c || null,
      iframeReady: false,
      loadingAddresses: false,
      customerAddresses: newCustomerAddresses,
    });
  };

  getAddressText = (address) => {
    let keys = [
      "country",
      "area",
      "block",
      "street",
      "building",
      "floor",
      "apartment",
      "avenue",
      "additional",
    ];

    if (this.props.config.language === "arabic") {
      keys[0] = "ar_country";
      keys[1] = "ar_area";
    }
    let addressString = "";
    let value;
    keys.forEach((key) => {
      value = address[key];
      if (value) {
        addressString = addressString.concat(value, ",");
      }
    });

    addressString = addressString.slice(0, -1);

    return addressString;
  };

  getAddressParams = (addressId) => {
    if (addressId === "New") {
      return "New";
    }
    const { customerAddresses } = this.state;
    const address = customerAddresses.find((a) => a.key === addressId);
    let keys = [
      "block",
      "street",
      "building",
      "floor",
      "apartment",
      "avenue",
      "additional",
      "branch_delivery_charge",
      "branch_id",
      "area_id",
      "country_id",
    ];

    const params = new URLSearchParams();

    keys.forEach((key) => {
      const value = address[key];
      if (value) {
        params.append(key, value);
      }
    });

    return params.toString();
  };

  render() {
    const { onClose, t, permissions, config, user } = this.props;

    const placement = config.language === "arabic" ? "left" : "right";

    const {
      loadingCustomers,
      selectedCustomerId,
      selectedCustomer,
      didSearch,
      customerAddresses,
      selectedAddress,
      selectedAddressId,
      selectedOrderTrackingId,
    } = this.state;

    const params = new URLSearchParams({
      customerName: selectedCustomer?.full_name || "",
      customerPhone: selectedCustomer?.phone || "",
      customerEmail: selectedCustomer?.email || "",
    }).toString();

    const iframeUrl = `https://${this.props.settings.domain}?src=Q7mZpL2xWa&userId=${user.user_id}&${params}&${selectedAddress}`;
    // const iframeUrl = `http://${"localhost:3001"}?src=Q7mZpL2xWa&userId=${user.user_id}&${params}&${selectedAddress}`;

    const canPickCustomer =
      permissions?.can_view_customers &&
      !(selectedAddressId && selectedCustomerId);

    return (
      <Drawer
        open={true}
        onClose={onClose}
        placement={placement}
        width={window.innerWidth < 768 ? "100%" : 480}
        title={t("Create Order")}
        destroyOnClose
      >
        {selectedOrderTrackingId && (
          <InvoiceViewer
            setLoading={(value) => this.setState({ loading: value })}
            selectedOrderReference={selectedOrderTrackingId}
            onClose={() =>
              this.setState({
                selectedOrderTrackingId: null,
                loading: false,

                // to reset
                selectedCustomerId: null,
                selectedCustomer: null,

                loadingAddresses: false,
                customerAddresses: null,
                selectedAddress: null,
                selectedAddressId: null,

                iframeReady: false,

                didSearch: false,
              })
            }
          />
        )}
        {canPickCustomer && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>
              {t("Select Customer")}
            </div>

            {loadingCustomers ? (
              <Spin />
            ) : (
              <Select
                loading={loadingCustomers}
                showSearch
                value={selectedCustomerId}
                style={{ width: "100%" }}
                placeholder={t("Search customer by name or phone")}
                filterOption={false} // IMPORTANT: disable local filtering
                defaultActiveFirstOption={false} // don't auto select first
                showArrow={false} // looks like pure search input
                notFoundContent={
                  this.state.searching ? <Spin size="small" /> : null
                }
                onSearch={this.onSearchCustomer} // your search handler
                onChange={this.onSelectCustomer}
              >
                {didSearch && (
                  <Option key={"New"} value={"New"}>
                    {t("New Customer")}
                  </Option>
                )}
                {(this.state.searchResults || []).map((c, index) => (
                  <Option key={`${c.id}-${index}`} value={c.id}>
                    {c.full_name} {c.phone || c.mobile || ""}
                  </Option>
                ))}
              </Select>
            )}
          </div>
        )}

        {canPickCustomer &&
          !selectedCustomer &&
          selectedCustomerId !== "New" && (
            <div style={{ padding: 12, opacity: 0.7 }}>
              {t("Choose a customer to continue")}
            </div>
          )}

        {canPickCustomer && selectedCustomer && selectedCustomer != "New" && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>
              {t("Select Address")}
            </div>

            {loadingCustomers ? (
              <Spin />
            ) : (
              <Select
                showSearch
                value={selectedAddressId}
                style={{ width: "100%" }}
                placeholder={t("Select Delivery Address")}
                onChange={(e) => {
                  this.setState({
                    selectedAddress: this.getAddressParams(e),
                    selectedAddressId: e,
                  });
                }}
              >
                <Option key={"New"} value={"New"}>
                  {t("New Address")}
                </Option>
                {(customerAddresses || []).map((address) => (
                  <Option value={address.key}>
                    {this.getAddressText(address)}
                  </Option>
                ))}
              </Select>
            )}
          </div>
        )}

        {((selectedCustomer && selectedAddress) ||
          selectedCustomerId === "New") && (
          <div style={{ height: "100%" }}>
            <iframe
              ref={this.iframeRef}
              src={iframeUrl}
              style={{ width: "100%", height: "100%", border: 0 }}
            />
          </div>
        )}
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.auth.settings,
    permissions: state.auth.permissions,
    config: state.config,
    user: state.auth.user,
  };
};

export default connect(mapStateToProps)(
  withNamespaces()(withRouter(CreateOrderDrawer)),
);
